import { DraftInvoiceRequest } from '@finance-review/models/invoice';
import { useCompanyCurrency } from 'modules/app/hooks/useCompanyCurrency';

export const useIsEligibleToSepa = () => {
  const companyCurrency = useCompanyCurrency();

  return (invoiceRequest: DraftInvoiceRequest.Entity) =>
    DraftInvoiceRequest.isEligibleToSepa(companyCurrency)(invoiceRequest);
};
